import { fillTFNDeclaration } from './tfn-declaration';
import { fillWorkRights } from './right-to-work';
const docFillFunctions = {
  tfnDeclaration: fillTFNDeclaration,
  workRights: fillWorkRights,
  // other types
};

export function fillDocument(document, changedField) {
  const fillDoc = docFillFunctions[changedField?.name?.split('.')[0]];

  if (fillDoc) {
    return fillDoc(document, changedField);
  }

  return document.fields;
}
